import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { findError, validationClasses } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';
import ValidationSpan from '@/components/errors/ValidationSpan';
import SystemFlag from '@/components/SystemFlag';
import { editUserGroup, updateUserGroupProperties } from '../actions/usergroups/update';
import UserGroupFieldInput from '../components/UserGroupFieldInput';
import UserGroupFieldHeader from '../components/UserGroupFieldHeader';

const UserGroupName = ({
  bpmn,
  canEdit,
  category,
  code,
  errorCoordinate = 't-30',
  isEditing,
  name,
  onChange,
  showEdit,
  saveErrors,
}) => {
  const validationError = findError(saveErrors, 'usergroup', [fields.NAME]);

  return (
    <>
      {!isEditing && (
        <UserGroupFieldHeader
          code={code}
          canEdit={canEdit}
          category={category}
          icon="users"
          isSystem={bpmn}
          renderSystemFlag={() => <SystemFlag messageId="usergroup.bpmn" />}
          showEdit={showEdit}
          value={name}
        />
      )}
      {canEdit && isEditing && (
        <>
          <ValidationSpan validationError={validationError} position="bottom" errorCoordinate={errorCoordinate} />
          <UserGroupFieldInput
            category={category}
            className={validationClasses(validationError, 'aridhia-usergroup-title')}
            code={code}
            icon="users"
            iconPosition="left"
            maxLength={globalFieldLengths.name}
            onChange={(value) => onChange(category, code, { name: value })}
            size="huge"
            text={name}
            type="name"
            value={name}
          />
        </>
      )}
    </>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { usergroups: { update: canEdit } } } },
  userGroups: { userGroups },
}, { category, code }) => {
  const {
    isEditing, saveErrors, name, bpmn,
  } = findResult(userGroups, category, code) || {
    bpmn: false,
    isEditing: false,
    name: '',
    saveErrors: [],
  };

  return {
    bpmn,
    canEdit,
    isEditing,
    name,
    saveErrors,
  };
};

const mapDispatchToProps = {
  showEdit: editUserGroup,
  onChange: updateUserGroupProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupName);
